import { format } from 'date-fns';
import { dateForEach } from '../../utils/dateForEach';
import { getCalendarDay } from '../../utils/getCalendarDay';
import { DATE_FORMAT } from '../../constants/dateTime';

/**
 * Возвращает hash-map c датами для быстрого поиска по ним
 * @param special конкретные дни, приоритетнее общего расписания
 */
export var getSpecialMap = function getSpecialMap(special) {
  if (!special || !special.length) {
    return null;
  }
  return special.reduce(function (acc, item) {
    acc[item.day] = item;
    return acc;
  }, {});
};
export var findSpecialDateTimeInfo = function findSpecialDateTimeInfo(date, special) {
  if (!special || !special[date]) {
    return null;
  }
  return special[date];
};
export var prepareFlatViewOrderInfo = function prepareFlatViewOrderInfo(dateTimeInfo) {
  var disabledDays = [];
  var general = dateTimeInfo.general,
    special = dateTimeInfo.special,
    availableDateInterval = dateTimeInfo.availableDateInterval;
  var specialMap = getSpecialMap(special);
  var availableDates = {};
  var nextDate = '';
  var nextNextDate = '';
  dateForEach(availableDateInterval, function (date) {
    var formattedDate = format(date, DATE_FORMAT);
    var specialDateInfo = findSpecialDateTimeInfo(formattedDate, specialMap);
    var weekday = date.getDay() + 1;
    var dateInfo = specialDateInfo || general.find(function (day) {
      return day.weekDay === weekday;
    });
    var availableTimeIntervals = dateInfo.availableTimeIntervals,
      step = dateInfo.step;
    if (!availableTimeIntervals.length) {
      disabledDays.push(getCalendarDay(date));
    } else {
      availableDates[formattedDate] = {
        availableTimeIntervals: availableTimeIntervals,
        step: step
      };
      if (!nextDate) {
        nextDate = formattedDate;
      } else if (!nextNextDate) {
        nextNextDate = formattedDate;
      }
    }
  });
  return {
    disabledDays: disabledDays,
    availableDates: availableDates,
    nextDate: nextDate,
    nextNextDate: nextNextDate
  };
};